<template>
  <div class="article article18">
    <p class="article-title">{{ $t("article18.title") }}</p>
    <img :src="articleImg185" />
    <p class="article-content" style="font-size: 12px; text-align: center">
      {{ $t("article18.p1") }}
    </p>
    <p class="article-content">{{ $t("article18.p2") }}</p>
    <img
      src="../../../assets/article/18-1 iPhone dual SIM.png"
      style="width: 30%; height: auto"
    />
    <p class="article-content" style="font-size: 12px; text-align: center">
      {{ $t("article18.p3") }}
    </p>
    <p class="article-content">{{ $t("article18.p4") }}</p>
    <img
      src="../../../assets/article/18-2 iPhone RedteaGo App for iPhone eSIM.png"
    />
    <p class="article-content" style="font-size: 12px; text-align: center">
      {{ $t("article18.p5") }}
    </p>
    <p class="article-content">{{ $t("article18.p6") }}</p>
    <p class="article-content">{{ $t("article18.p7") }}</p>
    <img :src="articleImg183" style="width: 80%" />
    <p class="article-content" style="font-size: 12px; text-align: center">
      {{ $t("article18.p8") }}
    </p>
    <img
      src="../../../assets/article/18-4 Ready to Go and Stay Connected.png"
      style="width: 50%"
    />
    <p class="article-content" style="font-size: 12px; text-align: center">
      {{ $t("article18.p9") }}
    </p>
    <!--    <p class="article-content">-->
    <!--      {{ $t('article18.p10') }}-->
    <!--      <a href="https://www.redteago.com/" target="_blank">www.redteago.com</a>-->
    <!--    </p>-->
    <p class="article-content">{{ $t("article18.p11") }}</p>
    <p class="article-content">
      {{ $t("article18.p12") }}
      <a href="http://www.redteamobile.com" target="_blank"
        >www.redteamobile.com</a
      >
      {{ $t("article18.p13") }}
    </p>
    <p class="article-content" style="font-weight: bold">
      {{ $t("article18.p14") }}
    </p>
    <ul style="margin-left: 20px">
      <li>
        <p class="article-content-1">
          {{ $t("article18.p15") }}
          <a
            href="https://business.facebook.com/redteamobile"
            target="_blank"
            >{{ $t("article18.p151") }}</a
          >
        </p>
      </li>
      <li>
        <p class="article-content-1">
          {{ $t("article18.p16") }}
          <a
            href="https://twitter.com/hashtag/RedteaGO?src=hashtag_click"
            target="_blank"
            >{{ $t("article18.p161") }}</a
          >
        </p>
      </li>
      <li>
        <p class="article-content-1">
          {{ $t("article18.p17") }}
          <a
            href="https://www.linkedin.com/feed/hashtag/?keywords=%23RedteaGOApp"
            target="_blank"
            >{{ $t("article18.p171") }}</a
          >
        </p>
      </li>
    </ul>
    <p class="article-content" style="font-weight: bold">
      {{ $t("article18.p18") }}
      <a
        href="https://www.prnewswire.com/news-releases/redtea-mobile-launches-esim-based-data-service-redteago-on-iphone-301009618.html"
        target="_blank"
        style="font-weight: 400"
        >{{ $t("article18.p181") }}</a
      >
    </p>
    <p class="article-content" style="font-weight: bold">
      {{ $t("article18.p19") }}
      <a
        href="https://finance.yahoo.com/news/redtea-mobile-launches-esim-based-010000029.html"
        target="_blank"
        style="font-weight: 400"
        >{{ $t("article18.p191") }}</a
      >
    </p>
    <p class="article-content" style="font-weight: bold">
      {{ $t("article18.p20") }}
    </p>
    <ul>
      <li>
        <p class="article-content-1">
          <a href="https://zhuanlan.zhihu.com/p/109427379" target="_blank">{{
            $t("article18.p201")
          }}</a>
        </p>
      </li>
      <li>
        <p class="article-content-1">
          <a href="https://zhuanlan.zhihu.com/p/109436269" target="_blank">{{
            $t("article18.p21")
          }}</a>
        </p>
      </li>
    </ul>
    <p class="article-content" style="font-weight: bold">
      {{ $t("article18.p22") }}
    </p>
    <ul>
      <li>
        <p class="article-content-1">
          {{ $t("article18.p23") }}
          <a
            href="http://news.cnr.cn/native/lmgd/20200226/t20200226_524992205.shtml"
            target="_blank"
            style="word-wrap: break-word; word-break: break-all"
            >{{ $t("article18.p231") }}</a
          >
        </p>
      </li>
      <li>
        <p class="article-content-1">
          {{ $t("article18.p24") }}
          <a
            href="http://news.163.com/20/0226/11/F6AEINTL000189DG.html"
            target="_blank"
            style="word-wrap: break-word; word-break: break-all"
            >{{ $t("article18.p241") }}</a
          >
        </p>
      </li>
      <li>
        <p class="article-content-1">
          {{ $t("article18.p25") }}
          <a href="https://tech.ifeng.com/c/7uLfMZ7hbGm" target="_blank">
            {{ $t("article18.p251") }}
          </a>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  // metaInfo: {
  //   meta: [
  //     {
  //       name: 'keyWords',
  //       content: 'RedteaGO on iPhone,RedteaGO App,App Store,local eSIM'
  //     },
  //     {
  //       name: 'description',
  //       content:
  //         'iPhone 11, iPhone 11 Pro and iPhone 11 Pro Max models, iPhone XS models and iPhone XR,data plans covering more than 50 countries and regions for overseas travel and business trips'
  //     }
  //   ]
  // },
  computed: {
    articleImg183() {
      return this.$store.state.articleImg183;
    },
    articleImg185() {
      return this.$store.state.articleImg185;
    },
  },
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
};
</script>
<style lang="less" scoped>
.article18 {
  li {
    list-style: none;
  }
  .article-content-1 {
    font-family: "Poppins-Light";
    font-size: 14px;
    text-align: left;
  }
}
</style>